module.exports = __webpack_public_path__ + "img/default_thumb.fb6dc9dd.png";